// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  TMessagesUnreadModel,
  IMappers,
  TMessagesUnreadResponse,
  IMessagesUnreadResponse,
  IMessagesUnreadResponseError,
} from './types';

export const defaultConfig: TMessagesUnreadModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v1/messages/unread/',
} as TMessagesUnreadModel;

export function createMessagesUnreadModel(): TMessagesUnreadModel {
  return {
    ...defaultConfig,
  };
}

export interface IMessagesUnreadOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchMessagesUnread<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IMessagesUnreadOptions<TResponse200, TResponse400>): Promise<TMessagesUnreadResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createMessagesUnreadModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesUnreadResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IMessagesUnreadResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TMessagesUnreadResponse;
}
